import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../../Common/PaginatedTable';
import { HiPencilAlt, HiXCircle } from 'react-icons/hi';
import { ClientInventoryMarkUp } from '../../../Models/ClientInventoryMarkUp';
import { formatNumbersDisplayOnly } from '../../../Utils';

export default function ClientInventoryMarkUpListTable({
  data,
  deleteClientInventoryMarkUp,
  editClientInventoryMarkUp,
}: {
  data: ClientInventoryMarkUp[];
  deleteClientInventoryMarkUp(id: number): void;
  editClientInventoryMarkUp: (feature: ClientInventoryMarkUp) => void;
}) {
  const columnHelper = createColumnHelper<ClientInventoryMarkUp>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => editClientInventoryMarkUp(info.row.original)}
          >
            <HiPencilAlt />
          </button>
          <button
            type='button'
            className='buttonCancel p-2'
            onClick={() => deleteClientInventoryMarkUp(info.getValue())}
          >
            <HiXCircle />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.inventoryType?.name, {
      id: 'inventoryTypeId',
      header: 'Type',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.markupPrice, {
      id: 'markupPrice',
      header: 'Mark Up',
      sortingFn: 'alphanumeric',
      cell: (info) => (
        <i>${formatNumbersDisplayOnly(info.row.original.markupPrice ?? 0)}</i>
      ),
      footer: (info) => info.column.id,
      filterFn: 'includesString',
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
      sorting: [
        {
          id: 'id',
          desc: false,
        },
      ],
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
